import { toSignificant } from '@/utilities/formatting';

import type { PortfolioDetailedReturns } from '../../hooks/usePortfolioDetailedReturns';

import { isType } from './utils';

type Holding = PortfolioDetailedReturns['holdings'][number];
type Transaction = Holding['detailedTransactions'][number];

type Props = Pick<Transaction, 'type' | 'splitRatio'>;

const getRatio = (splitRatio: number | null) => {
  if (splitRatio === null) return null;
  if (splitRatio < 1) return `1:${toSignificant(1 / splitRatio, 2)}`;
  return `${splitRatio}:1`;
};

export const TypeCell = ({ type, splitRatio }: Props) => {
  const safeType = type.toLowerCase();

  if (!isType(safeType)) return null;

  if (safeType === 'split') {
    return (
      <span className="font-strong uppercase text-solid">
        {splitRatio && splitRatio < 1
          ? `Reverse Split ${getRatio(splitRatio)}`
          : `Split ${getRatio(splitRatio)}`}
      </span>
    );
  }

  if (safeType === 'dividend') {
    return <span className="font-strong uppercase text-solid">Dividend</span>;
  }

  if (safeType === 'buy') {
    return <span className="font-strong uppercase text-good">Buy</span>;
  }

  if (safeType === 'sell') {
    return <span className="font-strong uppercase text-bad">Sell</span>;
  }

  return null;
};
